module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Align-center-f64d44fc9de350552cf0e3e8ef8082f6.svg";